import styled from 'styled-components'

export const Container = styled.section`
  align-items: center;
  background-color: var(--primary);
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`

export const InfoContainer = styled.div`
  display: flex;
  justify-content: space-around;
  max-width: 1240px;

  padding: 32px 28px 0;

  figure.desktop {
    margin-left: -4%;
  }


  @media (max-width: 950px) {
    flex-direction: column;
    padding-inline: 0;

    figure.desktop {
      display: none;
    }

    figure.mobile {
      margin-top: -4%;
    }
  }

  @media (max-width: 764px) {
    figure.mobile {
      overflow: hidden;

      img {
        margin-left: -8%;
        width: 116%;
      }
    }
  }

  @media (min-width: 951px) {
    figure.mobile {
      display: none;
    }
  }
`

export const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 478px;
  z-index: 0;

  h1 {
    color: var(--secondary);
    font-size: 48px;
    line-height: 56px;
    margin-bottom: 24px;
  }

  p {
    color: var(--white);
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 32px;

    span {
      color: var(--secondary);
      font-weight: 700;
    }
  }

  @media (max-width: 950px) {
    padding-inline: 32px;
    max-width: initial;
  }

  @media (max-width: 764px) {
    h1 {
      font-size: 32px;
      line-height: 40px;
    }
  }
`
